import React from "react";
import { SurveyQnaSection } from "./survey-qna-data";

type SurveyQnaProps = {
  sections: SurveyQnaSection[]
};

const SurveyQna: React.FC<SurveyQnaProps> = ({ sections }) => {
  if (!sections.length) {
    return null;
  }

  return (
    <section className="bg-white">
      <div className="max-w-[2500px] mx-auto w-[calc(100%_-_10%)] flex flex-col">
        {sections?.map((section) => {
          return (
            <div
              key={section.id}
              className={`relative flex flex-col gap-[40px] 2xl:flex-row 2xl:gap-[80px]`}
            >
              <div className="2xl:max-w-[400px] 2xl:w-full w-max 2xl:pr-0 pr-[40px] h-max relative xl:sticky md:top-[90px] 2xl:top-[30px] 2xl:py-[100px] bg-white pt-10 md:pt-0">
                <p className="text-[#225bd4] text-[24px] leading-[160%] font-semibold italic">
                  {section.name}
                </p>
              </div>

              <div className="flex-1 flex flex-col gap-[40px] border-l py-[10px] md:py-[100px] border-[#ECF0F6] pl-[5px] md:pl-[60px]">
                {section.summaries?.map((entry) => (
                  <article key={Number(entry.id)} className="flex flex-col gap-4">
                    <h3 className="text-[#00040b] text-[24px] md:text-[26px] leading-[1.6] font-semibold">
                      {entry.question}
                    </h3>
                    <p className="text-[#5c5c5e] text-[18px] md:text-[20px] leading-[1.6] font-normal">
                      {entry.answer}
                    </p>
                  </article>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SurveyQna;
